import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:4000/'
      : 'https://tstatsapi.stats-insight.com/'
  ),
  withCredentials: true,
  timeout: 10000
})

export const api_authUserLogin = async (payload) => {
  console.log('Get User Login')
  try {
    const { data } = await instance.post('usr/login', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    console.log(err)
    return { status: 'error', message: err.message }
  }
}

// Uses the shared credentialed client and its 10-second timeout; no client-side cookie mutation.
export const api_authUserLogout = async () => {
  const { data } = await instance.post('/usr/logout')
  return data
}

// Read the live game state for the HUD (inning / B-S-O / batter / pitcher /
// pitch counts). Returns the raw envelope { status, data }; useGameState owns
// the degrade-on-failure handling so callers never see a throw block recording.
export const api_getGameState = async (payload) => {
  const { data } = await instance.post('/game/gameState', payload)
  return data
}

// All leagues that have games (for the 賽事 selector). Returns the raw envelope
// { status, data:[{id,name,games}] }.
export const api_getLeagues = async () => {
  const { data } = await instance.get('/game/leagues')
  return data
}

export const api_getVideoSignedURL = async (payload) => {
  console.log('Get Video URL')
  try {
    const { data: { url } } = await instance.post('/video/getVideoURL', payload)
    // console.log("url:", url)
    return url
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}